
import React, { Fragment, useMemo } from 'react'
import { Dropdown } from 'react-bootstrap'

import InputDropdownToggle from './InputDropdownToggle'
import InputDropdownMenu from './InputDropdownMenu'
import InputDropdownItem from './InputDropdownItem'
import InputDropdownToggleSelected from './InputDropdownToggleSelected'

interface Props {
  value: any
  placeholder?: string
  options: any[]
  renderItem?: (option: any) => any
  onChange: (e: any) => void
}

const InputDropdown = ({ value, placeholder, options, renderItem, onChange }: Props) => {

  const selected = useMemo(() => options.find((o: any) => o._id === value), [ value ])

  return (
    <Dropdown>
      {!selected && (
        <Dropdown.Toggle as={InputDropdownToggle}>
          {placeholder}
        </Dropdown.Toggle>
      )}
      {selected && (
        <Dropdown.Toggle as={InputDropdownToggleSelected} onClear={() => onChange('')}>
          {selected && `${selected.name} ${selected.surname}`}
        </Dropdown.Toggle>
      )}

      <Dropdown.Menu as={InputDropdownMenu}>
        {options.map((option: any, i: number) => (
          <Fragment key={option._id}>
            <Dropdown.Item key={i}
              as={InputDropdownItem}
              onClick={() => onChange(option._id)}
            >
              {!renderItem && option.label}
              {renderItem && renderItem(option)}
            </Dropdown.Item>
          </Fragment>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default InputDropdown
